import { BoxContainer, BoxContainerProps, CircleIcon, FluidCanvas, PrimaryButton, ReactIcons } from "@kalyzee/kalyzee-ui";

import workBoxStyles from "./WorkBox.module.css";
import styles from "./PlayerWorkBox.module.css";
import React from "react";
import clsx from "clsx";

export interface PlayerWorkBoxProps {
  children: React.ReactNode;
  label: string;
  labelInfo?: string;
  overlayMode?: BoxContainerProps["mode"];
  overlayContent?: React.ReactNode;
  extraHeaderContent?: React.ReactNode;
  className?: string;
  topBarClassName?: string;
  audio?: boolean;
  video?: boolean;
  isMe?: boolean;
  isHighlighted?: boolean;
  isPlayingSound?: boolean;
  nativeProps?: React.HTMLAttributes<HTMLDivElement>;
  idleAnimation?: boolean;
  onChangeAudio?: () => void;
  onChangeVideo?: () => void;
}


const _PlayerWorkBox: React.FC<PlayerWorkBoxProps> = ({
  children,
  label,
  labelInfo,
  overlayMode,
  overlayContent,
  extraHeaderContent,
  className,
  topBarClassName,
  audio,
  video,
  isMe,
  isHighlighted,
  isPlayingSound,
  nativeProps,
  idleAnimation,
  onChangeAudio,
  onChangeVideo,
}) => {
  const left: React.ReactNode[] = [];
  if (extraHeaderContent) {
    left.push(extraHeaderContent);
  }
  if (isHighlighted) {
    left.push(<ReactIcons.Hand className={styles.nameIcon} />);
  } else if (isMe) {
    left.push(<ReactIcons.Home className={styles.nameIcon} />);
  }
  left.push(<span key="label" className={workBoxStyles.label}>{label}</span>);
  if (labelInfo) {
    left.push(
      <span key="youLabel" className={workBoxStyles.labelInfo}>{labelInfo}</span>
    );
  }

  const right: React.ReactNode[] = [];
  if (video !== undefined) {
    right.push(
      <PrimaryButton 
        key="video" 
        onClick={onChangeVideo}
      >
        <CircleIcon.Variants.Camera
          style={{ fontSize: "0.75em" }}
          disabled={!video}
        />
      </PrimaryButton>
    );
  }
  if (audio !== undefined) {
    right.push(
      <PrimaryButton
        key="audio"
        onClick={onChangeAudio}
      >
        <CircleIcon.Variants.Mic
          style={{ fontSize: "0.75em" }}
          disabled={!audio}
        />
      </PrimaryButton>
    );
  }

  const renderIdleAnimation = () => {
    if (!idleAnimation) return null;
    return (
      <div className={styles.idleAnimationContainer}>
        <FluidCanvas speed={0.5} shapeSize="big" />
      </div>
    );
  };
  
  return (
    <BoxContainer
      className={clsx({
        [styles.container]: true,
        [styles.highlighted]: isHighlighted,
        [styles.playingSound]: isPlayingSound,
      }, className)}
      topBarProps={{
        left,
        right: right.length ? right : undefined,
        className: clsx(styles.playerTopBar, topBarClassName),
      }}
      mode={overlayMode}
      overlayContent={overlayContent}
      nativeProps={nativeProps}
    >
      {children}
      {renderIdleAnimation()}
    </BoxContainer>
  );
};

export const PlayerWorkBox = React.memo(_PlayerWorkBox);